<template>
  <forgot-password v-if="authViewState === 'forgotPassword'" />
  <sign-up v-else-if="authViewState === 'signUp'" />
  <sign-in v-else />
</template>

<script>
import SignIn from './AuthSignIn.vue'
import ForgotPassword from './ForgotPassword.vue'
import SignUp from './AuthSignUp.vue'

export default {
  name: 'Authenticator',
  components: {
    SignIn,
    ForgotPassword,
    SignUp
  },
  props: {
    authState: { type: String, required: true },
    authData: { type: Object, required: true }
  },
  data: function () {
    return {}
  },
  computed: {
    authViewState() {
      return this.$store.state.auth.authViewState
    }
  },
  methods: {
    onAuthStateChange(newState, newData) {
      const data = Object.assign({}, this.authData, newData)
      this.authState = newState
      this.authData = data
      if (newState === 'authenticated') {
        this.onAuthenticated(data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
  @import '~@/assets/styles/auth.scss';
</style>

